import { Post, User } from './type';

const fetchUser = (username: string, timestamp?: number): Promise<User> => {
  let url = `${getBaseUrl()}/${username}/profile`;
  if (timestamp) {
    url += `?v=${timestamp}`;
  }
  return fetchData<User>(url);
};

const fetchPosts = (
  username: string,
  until?: string,
  timestamp?: number,
): Promise<Post[]> => {
  let url = `${getBaseUrl()}/${username}/posts`;
  const params = new URLSearchParams();
  if (until) {
    params.set('until', until);
  }
  if (timestamp) {
    params.set('v', timestamp.toString());
  }
  const queryString = params.toString();
  if (queryString) {
    url += `?${queryString}`;
  }
  return fetchData<Post[]>(url);
};

const clickPost = (username: string, p: Post): Promise<any> => {
  const createdISOStr = new Date(p.created).toISOString();
  return fetchData<any>(
    `${getBaseUrl()}/${username}/click/${p.id}?created=${createdISOStr}`,
  );
};

async function fetchData<T>(url: string): Promise<T> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  return (await response.json()) as Promise<T>;
}

function getBaseUrl(): string {
  return `/api/${window.TA.networkName}`;
}

export const API = {
  fetchPosts,
  fetchUser,
  clickPost,
};
